import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIcon, SvgIconPropsType } from 'src/ui/assets/icons/utils';

export const ChristmasIcon = observer('ChristmasIcon', ({ className, onClick }: SvgIconPropsType): JSX.Element => {
    return (
        <SvgIcon
            width='24'
            height='24'
            viewBox='0 0 50 50'
            fill='#061A32'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
            onClick={onClick}
        >
            <path
                d='M13,25c0-.6.49-1.09,1.09-1.09h1.73s-.87-.86-.87-.86c-.43-.43-.43-1.12,0-1.54.43-.43,1.12-.43,1.54,0l2.41,2.41h4.2s-2.1-3.64-2.1-3.64l-3.29-.88c-.58-.16-.93-.75-.77-1.34.16-.58.75-.93,1.34-.77l1.18.32-.87-1.5c-.3-.52-.12-1.19.4-1.49.52-.3,1.19-.12,1.49.4l.87,1.5.32-1.18c.16-.58.75-.93,1.34-.77.58.16.93.75.77,1.34l-.88,3.29,2.1,3.64,2.1-3.64-.88-3.29c-.16-.58.19-1.18.77-1.34.58-.16,1.18.19,1.34.77l.32,1.18.87-1.5c.3-.52.97-.7,1.49-.4.52.3.7.97.4,1.49l-.87,1.5,1.18-.32c.58-.16,1.18.19,1.34.77.16.58-.19,1.18-.77,1.34l-3.29.88-2.1,3.64h4.2s2.41-2.41,2.41-2.41c.43-.43,1.12-.43,1.54,0,.43.43.43,1.12,0,1.54l-.87.86h1.73c.6,0,1.09.49,1.09,1.09s-.49,1.09-1.09,1.09h-1.73s.87.86.87.86c.43.43.43,1.12,0,1.54-.43.43-1.12.43-1.54,0l-2.41-2.41h-4.2s2.1,3.64,2.1,3.64l3.29.88c.58.16.93.75.77,1.34-.16.58-.75.93-1.34.77l-1.18-.32.87,1.5c.3.52.12,1.19-.4,1.49-.52.3-1.19.12-1.49-.4l-.87-1.5-.32,1.18c-.16.58-.75.93-1.34.77-.58-.16-.93-.75-.77-1.34l.88-3.29-2.1-3.64-2.1,3.64.88,3.29c.16.58-.19,1.18-.77,1.34-.58.16-1.18-.19-1.34-.77l-.32-1.18-.87,1.5c-.3.52-.97.7-1.49.4-.52-.3-.7-.97-.4-1.49l.87-1.5-1.18.32c-.58.16-1.18-.19-1.34-.77-.16-.58.19-1.18.77-1.34l3.29-.88,2.1-3.64h-4.2s-2.41,2.41-2.41,2.41c-.43.43-1.12.43-1.54,0-.43-.43-.43-1.12,0-1.54l.87-.86h-1.73c-.6,0-1.09-.49-1.09-1.09h0Z'
                fill='fill'
            />
        </SvgIcon>
    );
});
